import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { Link } from "react-router-dom";

const ClientPolicyRequirementInfo = (props) => {
  const { policy = {} } = props;
  const [requirements, setRequirements] = useState([]);
  const [policyItemRequirement, setPolicyItemRequirement] = useState({});
  let policyRequirement = new Object();

  const { api, abortSignal, auth } = useApi();

  useEffect(() => {
    const getRequirements = async () => {
      const { data: ptr } = await api.list(
        `/policies/policy-types/${policy?.PolicyTypeId}/requirements`
      );

      const { data: pr } = await api.list(
        `/products/${policy?.ProductId}/requirements`
      );

      let removeDups = [...ptr, ...pr];
      removeDups = removeDups.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.place === value.place && t.name === value.name
          )
      );

      if (policy.policyRequirement) {
        const selectTypeRequirements = removeDups;

        const saveRequirements = JSON.parse(policy.policyRequirement);
        //console.log(saveRequirements);

        selectTypeRequirements.forEach((requirement) => {
          for (const [key, value] of Object.entries(saveRequirements)) {
            if (key === requirement.id && requirement.identifier) {
              policyRequirement[requirement.identifier] = value;
            }
          }
        });

        setPolicyItemRequirement(policyRequirement);
      }

      setRequirements([...removeDups]);
    };

    getRequirements();
  }, [policy, auth]);

  //const policyRequirement = JSON.parse(policy.policyRequirement);
  let info = policy.title;
  return <Link to={`/client-account/policy-item/${policy?.id}`}>{info}</Link>;
};

export default ClientPolicyRequirementInfo;
